import querystring from 'querystring';

import _ from 'lodash';

import splitUrl from './splitUrl';

const filterEmptyKeys = obj => _.pickBy(obj, (val, key) => !!key);

const extractParams = (url = '') => {
  const params = querystring.parse(splitUrl(url).queryString);
  // Handles a params object that was extracted from an URL with a trailing `&`,
  // which would result in an empty key/value pair.
  return filterEmptyKeys(params);
};

export default extractParams;
